import React from 'react';
import Loadable from 'react-loadable';
import Helmet from 'react-helmet';

const AsyncExploreFeedRoute = Loadable({
  loader: () =>
    import(/* webpackChunkName: "explore_feed" */ './AsyncExploreFeedRoute.js'),
  loading: () => (
    <Helmet bodyAttributes={{ style: 'background-color: white;' }} />
  )
});

export default AsyncExploreFeedRoute;
